/*@ngInject*/
const ParameterizedActionController = function ($rootScope, $scope, $element, $stateParams, $timeout, coreMediator, dataSetUtil, localization, ruleMediator, umStudioConstant, ruleModel, ruleUtil, dataSetType) {

    localization.getTranslations().then((translations) => {

        this.defaultPrompt = {
            name: _.get(translations, 'parameterizedAction.dropdownPrompt')
        };
        this.defaultPrompt.value = this.defaultPrompt.name;
        this.variables = [];
        this.selectedPrompt = {
            name: '',
            value: ''
        };
        this.selectedPrompt.value = this.selectedPrompt.name;

        this.init = function () {
            if (this.getActionType() === '/VariableValue') {
                this.selectedPrompt = {
                    name: this.parameter.value.variableName,
                    isVariableValue: true
                };
                this.selectedPrompt.value = this.selectedPrompt.name;
            } else if (this.getActionType() === '/DataSetItemValue') {
                const dataSetParams = {name: this.parameter.value.datasetName};
                dataSetUtil.getDataSet(dataSetParams).then((result) => {
                    this.dataSetItems = result.items;
                    this.dataSetType = result.type;
                    this.setSelectedPrompt();
                    this.buildItemsList();
                });
            } else if (this.getActionType() === '/EntityUriValue') {
                this.activeList = {};
            }

            this.tooltip ={};
            this.tooltip.type='';
            this.tooltip.message = this.parameter.value.valueString;
            this.getVariables();
        };

        this.getActionType = function () {
            return _.split(this.parameter.value.objectUri, '/' + this.parameter.value.id)[0];
        };

        this.onLiteralValueChange = _.debounce(() => {
            $timeout(() => {
                $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
            }, 0);
        }, 250);

        this.changeDataSetValue = function (item) {
            const name = _.isEmpty(item) ? '' : (item.value || item.variableName);
            this.selectedPrompt = {
                name: name,
                value: name
            };

            if (item.variableName) {
                this.parameter.value = {};
                this.parameter.value.objectUri = '/VariableValue';
                this.parameter.value.variableName = item.variableName;
                if (this.parameter.typeName) {
                    this.parameter.value.variableMethod = ruleUtil.typeNameToVariableMethodMap[this.parameter.typeName];
                }
            } else {
                if (this.dataSetType === dataSetType.PRODUCT_FIELD_DEPENDENT) {
                    this.parameter.value.entityUri = `com.firstbest.underwriting.data.EnhancedDynamicDataItem:com.firstbest.data.DataItemKey::${this.parameter.value.datasetName}::${name}`;
                } else {
                    this.parameter.value.entityUri = `com.firstbest.data.DataItem:com.firstbest.data.DataItemKey::${this.parameter.value.datasetName}::${name}`;
                }
            }

            $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
        };

        this.getLabel = function () {
            const name = `{${this.parameter.name}}`;
            const array = _.split(this.displayExpression, name);
            const array2 = _.split(array[0], ', ');
            return array2[array2.length - 1];
        };

        this.setSelectedPrompt = function () {
            let promptValue = this.parameter.value.variableName,
                selectedPromptPresent = false;

            if (!promptValue) {
                promptValue = _.split(this.parameter.value.entityUri, '::', 3)[2];
            }

            this.selectedPrompt = this.defaultPrompt;
            // select in dataSetItems
            _.each(this.dataSetItems, (item) => {
                if (item.value === promptValue) {
                    selectedPromptPresent = true;
                    this.selectedPrompt = {
                        name: item.name,
                        value: item.value
                    };
                }
            });

            // select in variables
            if (!selectedPromptPresent) {
                _.each(this.variables, (variable) => {
                    if (promptValue === variable.variableName) {
                        this.selectedPrompt = {
                            name: variable.variableName,
                            isVariableValue: true
                        };
                        this.selectedPrompt.value = this.selectedPrompt.name;
                    }
                });
            }
        };

        this.getVariables = function () {
            this.variables = [];
            this.allSubConditions = [];

            const rule = ruleModel.getRule(parseInt($stateParams.ruleId));
            let selectedPromptPresent = false;

            this.setAllSubConditions(rule.condition.subconditions);

            _.each(this.allSubConditions, (item) => {
                if (!_.isNil(item.lhs) && !_.isEmpty(item.lhs.variableName)) {
                    const lhsObject = {};
                    lhsObject.variableName = item.lhs.variableName;
                    if (this.selectedPrompt.value === item.lhs.variableName) {
                        selectedPromptPresent = true;
                    }
                    this.variables.push(lhsObject);
                }
                if (!_.isNil(item.rhs) && !_.isEmpty(item.rhs.variableName)) {
                    const rhsObject = {};
                    rhsObject.variableName = item.rhs.variableName;
                    if (this.selectedPrompt.value === item.rhs.variableName) {
                        selectedPromptPresent = true;
                    }
                    this.variables.push(rhsObject);
                }
            });

            if (!selectedPromptPresent) {
                this.selectedPrompt = this.defaultPrompt;
            }

            this.buildItemsList();
        };

        this.buildItemsList = function () {
            this.itemsList = [];

            _.each(this.variables, (variable) => {
                variable.name = variable.variableName;
                variable.value = variable.name;
                variable.grouping = _.get(translations, 'parameterizedAction.ruleVariablesGroupingLabel');
                this.itemsList.push(variable);
            });

            _.each(this.dataSetItems, (dataSetItem) => {
                this.itemsList.push(dataSetItem);
            });
        };

        this.setAllSubConditions = function (subconditions) {
            _.each(subconditions, (item) => {
                if (_.isNil(item.subconditions)) {
                    this.allSubConditions.push(item);
                } else {
                    this.setAllSubConditions(item.subconditions);
                }
            });
        };

        $scope.$on(umStudioConstant.event.RULE_VARIABLE_VALUE_CHANGED, () => {
            this.variables = [];
            this.variables = ruleModel.getVariableValueList();
            this.buildItemsList();

            if (this.selectedPrompt.isVariableValue) {
                let selectedPromptPresent = false;
                _.each(this.variables, (variable) => {
                    if (this.selectedPrompt.value === variable.variableName) {
                        selectedPromptPresent = true;
                    }
                });

                if (!selectedPromptPresent) {
                    this.selectedPrompt = this.defaultPrompt;
                    this.parameter.value.variableName = null;
                }
            }
        });

        this.init();
    });
};

angular.module('umCore')
    .controller('parameterizedActionController', ParameterizedActionController);
